import CompLayout from "@/pcomponents/comp/layout/layout";
import TextBookListViewArea from "@/pages/comp/book_order/comp_textbook/common/textbook_list_view";

function TextBookListViewPage() {
  return (
    <CompLayout>
      <TextBookListViewArea></TextBookListViewArea>
    </CompLayout>
  );
};
export default TextBookListViewPage;